module.exports = __webpack_public_path__ + "static/img/Derco.b1ab5f4.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Derco.gif
// module id = eSPU
// module chunks = 1